// src/utils/guestSpendingCsvUtils.js

/**
 * Convert an array of objects into a CSV string.
 * Uses the object keys of the first element as headers.
 * @param {Object[]} objArray
 * @returns {string}
 */
export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) {
      str = str.replace(/"/g, '""');
    }
    return `"${str}"`;
  };

  // header row
  let csv = headers.map(escape).join(",") + "\r\n";

  // data rows
  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Export a CSV containing Guest Count and Avg Spend per Guest by month.
 *
 * @param {Object} params
 * @param {{ labels: string[], datasets: Array }} params.chartData
 * @param {string} params.selectedYear
 * @param {string|Object} params.range    // JSON string or object with $gte and $lte
 * @param {string} params.storess         // store name
 * @param {string} [params.fileName]      // download filename (default 'GuestsAndSpending.csv')
 */
export function exportGuestsAndSpendingCSV({
  chartData,
  selectedYear,
  range,
  storess,
  fileName = "GuestsAndSpending.csv",
}) {
  if (!chartData || !chartData.labels || !chartData.datasets) {
    console.error("exportGuestsAndSpendingCSV: invalid chartData");
    return;
  }

  // Extract arrays from datasets
  const guestDataset = chartData.datasets.find(
    (ds) => ds.label === "Guest Count"
  );
  const avgSpendDataset = chartData.datasets.find(
    (ds) => ds.label === "Avg Spend per Guest"
  );
  if (!guestDataset || !avgSpendDataset) {
    console.error("exportGuestsAndSpendingCSV: missing required datasets");
    return;
  }
  const totalGuests = guestDataset.data;
  const avgSpendPerGuest = avgSpendDataset.data;

  // Parse range
  const dateRange = typeof range === "string" ? JSON.parse(range) : range || {};

  // Build row objects
  const rows = chartData.labels.map((label, i) => ({
    Brand: "Angels Pizza",
    Store: storess || "All Stores",
    Year: `${selectedYear}${
      dateRange.$lte?.split("T")[0] || ""
    } ${selectedYear}${dateRange.$gte?.split("T")[0] || ""}`,
    TotalGuests: totalGuests[i],
    AvgSpendPerGuest: avgSpendPerGuest[i],
  }));

  // Convert to CSV
  const csvString = convertToCSV(rows);
  if (!csvString) {
    console.warn("exportGuestsAndSpendingCSV: no data to export");
    return;
  }

  // Trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
